import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import {
  Button,
  CircularProgress,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SearchIcon from "@mui/icons-material/Search";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { viewPDF } from "../../utils/viewPDF";
import { uploadFile } from "../../utils/uploadToAzure";
import { CheckBox } from "@mui/icons-material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3,
  textAlign: "center",
};

const Tenders = ({ tenders, isLoading, activeTab, getTenders, totalCount }) => {
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const [tenderId, setTenderId] = useState();
  const [openNewModal, setOpenNewModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [openEMDModal, setOpenEMDModal] = useState(false);
  const [tender, setTender] = useState();
  const [emdDetails, setEmdDetails] = useState();
  const [fileNames, setFileNames] = useState({
    document: "",
  });
  const [searchText, setSearchText] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 1,
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [uploading, setUploading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [purchase, setPurchase] = useState();
  const [openPurchase, setOpenPurchase] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedTenders, setSelectedTenders] = useState([]);

  const totalPurchaseAmount = selectedTenders.reduce(
  (sum, tender) => sum + (tender.tender.purchaseAmount || 0),
  0
);

  const validateForm = () => {
    const newErrors = {};
    const data = emdDetails || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.utr)) newErrors.utr = "UTR Number is required";
    if (isEmpty(data.document)) newErrors.document = "Document is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleOpenNewModal = () => setOpenNewModal(true);

  const handleOpenEMDModal = async (id) => {
    setOpenEMDModal(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/tender/get-by-id?tenderId=${id}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTender(res.data);
    } catch (error) {
      console.error("Error updating tender status:", error);
    }
  };

  const handleOpenImportModal = () => setOpenImportModal(true);

  const handleClose = () => {
    setOpenNewModal(false);
    setOpenImportModal(false);
    setOpenEMDModal(false);
    setEmdDetails();
    setFileNames({ document: "" });
    setOpenPurchase(false)
  };

  const handleQualification = async (id) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/vtq?vendorId=${vendorId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setTenderId(id);
      if (res.data === false) {
        handleOpenNewModal();
      } else {
        handleOpenImportModal();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveVendorTender = async (id) => {
    setLoading(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-tender?vtId=${id}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      getTenders();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleGoToNewForm = () => {
    localStorage.setItem("form", "NEW");
    navigate(`/vendor/dashboard/${tenderId}/qualification`);
  };

  const handleImportForm = () => {
    localStorage.setItem("form", "IMPORT");
    navigate(`/vendor/dashboard/${tenderId}/qualification`);
  };

  const columns = [
    // {
    //   field: "tenderId",
    //   headerName: "Checkbox",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <span
    //       className="table-title"
    //       onClick={() =>
    //         navigate(`/vendor/dashboard/${params.row.tender.tenderId}`)
    //       }
    //     >
    //       {!params.row.tender.isBorne && params.row.vtStatus === "INTERESTED" &&
    //       <CheckBox />
    //       }
    //     </span>
    //   ),
    // },
    {
      field: "title",
      headerName: "Title",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() =>
            navigate(`/vendor/dashboard/${params.row.tender.tenderId}`)
          }
        >
          {params.row.tender.title}
        </span>
      ),
    },
    {
      field: "tenderType",
      headerName: "Tender Type",
      flex: 1,
      renderCell: (params) =>
        params.row.tender.type
          ? params.row.tender.type.charAt(0).toUpperCase() +
            params.row.tender.type.slice(1).toLowerCase()
          : "",
    },
    {
      field: "tenderPublishDate",
      headerName: "Tender Publish Date",
      flex: 1,
      renderCell: (params) => formatDate(params.row.tender.tenderPublishDate),
    },
    {
      field: "bidSubmissionEndDate",
      headerName: "Bid Close Date",
      flex: 1,
      renderCell: (params) =>
        formatDateTime(params.row.tender.bidSubmissionEndDate),
    },
    {
      field: "vtStatus",
      headerName: "Status",
      flex: 1.5,
      renderCell: (params) => {
        const statusColors = {
          INTERESTED: "#35D85B",
          SHORTLISTED: "#35D85B",
          QDETAILS_SUBMITTED: "#1DCCE8",
          QSTAGE_1: "#1DCCE8",
          PURCHASE_SUBMITTED: "#1DCCE8",
          QSTAGE_2: "#1DCCE8",
          QUALIFIED: "#2BD652",
          EMD_CMD_SUBMITTED: "#5EC9FF",
          EMD_CMD_ACCEPTED: "#5EC9FF",
          BID_OPEN: "#35D85B",
          BID_CLOSED: "rgb(190, 179, 179)",
          BID_SUBMITTED: "#35D85B",
          REBID: "#35D85B",
          DISQUALIFIED: "#FA6459",
          AWARDED: "#0381F3",
        };
        const statusLabels = {
          QDETAILS_SUBMITTED: "Qualification Details Submitted",
          QSTAGE_1: "Qualification Details Submitted",
          QSTAGE_2: "Qualification Details Submitted",
          PURCHASE_SUBMITTED: "Purchase Details Submitted",
          QUALIFIED: "Vendor Qualified",
          INTERESTED: "Interested",
          SHORTLISTED: "Shortlisted",
          EMD_CMD_SUBMITTED: "EMD/CMD Submitted",
          EMD_CMD_ACCEPTED: "EMD/CMD Accepted",
          BID_OPEN: "Bid Open",
          BID_CLOSED: "Bid Closed",
          BID_SUBMITTED: "Bid Submitted",
          REBID: "Rebid",
          DISQUALIFIED: "Disqualified",
          AWARDED: "Awarded",
        };
        return (
          <span
            style={{
              background: statusColors[params.row.vtStatus],
              borderRadius: "15px",
              padding: "5px 15px",
              fontWeight: 600,
            }}
          >
            {statusLabels[params.row.vtStatus]}
          </span>
        );
      },
    },
    activeTab !== "POSTBIDDING" && {
      field: "action",
      headerName: "Action",
      flex: 2,
      renderCell: (params) =>
        params.row.vtStatus === "SHORTLISTED" ? (
          <>
            {(params.row.tender.status === "UPCOMING" ||
              params.row.tender.status === "ACCEPTING_BIDS") && (
              <>
                <Button
                  className="btn-contained"
                  sx={{ margin: "0 !important", fontSize: "12px" }}
                  onClick={() =>
                    handleQualification(params.row.tender.tenderId)
                  }
                >
                  Submit Qualification Details
                </Button>
              </>
            )}
            <Button
              sx={{
                width: "0",
                color: "#000",
                "&:hover": { color: "#EB2B0B" },
              }}
              onClick={() => handleRemoveVendorTender(params.row.vtId)}
            >
              <DeleteOutlineIcon />
            </Button>
          </>
        ) : params.row.vtStatus === "QUALIFIED" ? (
          <>
            {(params.row.tender.status === "UPCOMING" ||
              params.row.tender.status === "ACCEPTING_BIDS") && (
              <Button
                className="btn-contained"
                sx={{ margin: "0 !important", fontSize: "12px" }}
                onClick={() => handleOpenEMDModal(params.row.tender.tenderId)}
              >
                Submit EMD Details
              </Button>
            )}
          </>
        ) : params.row.vtStatus === "BID_OPEN" ? (
          <>
            <Button
              className="btn-contained"
              sx={{ margin: "0 !important", fontSize: "12px" }}
              onClick={() => handleNavigateToBid(params.row.tender.tenderId)}
            >
              Submit Bid
            </Button>
          </>
        ) : params.row.vtStatus === "REBID" &&
          new Date(params.row.tender.rebidStartDate) <= new Date() &&
          new Date(params.row.tender.rebidEndDate) >= new Date() ? (
          <>
            <Button
              className="btn-contained"
              sx={{ margin: "0 !important", fontSize: "12px" }}
              onClick={() =>
                navigate(
                  `/vendor/dashboard/submit-rebid/${params.row.tender.tenderId}`
                )
              }
            >
              Submit Rebid
            </Button>
          </>
        ) : params.row.vtStatus === "INTERESTED" ? (
          <Button
              className="btn-contained"
              sx={{ margin: "0 !important", fontSize: "12px" }}
              onClick={() => setOpenPurchase(true)}
            >
              Submit Purchase
            </Button>
        ) : null,
    },
  ];

  const handleNavigateToBid = async (id) => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft-bid/check?vendorId=${vendorId}&tenderId=${id}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      if (res.data === true) {
        navigate(`/vendor/dashboard/submit-bid/draft/${id}`);
      } else {
        navigate(`/vendor/dashboard/submit-bid/${id}`);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  const rows =
    tenders &&
    tenders.map((tender) => ({
      ...tender,
      tenderPublishDate: formatDate(tender.tenderPublishDate),
      bidSubmissionStartDate: formatDateTime(tender.bidSubmissionStartDate),
      bidSubmissionEndDate: formatDateTime(tender.bidSubmissionEndDate),
    }));

  useEffect(() => {
    const mappedRows =
      tenders &&
      tenders.map((tender) => ({
        ...tender,
        tenderPublishDate: formatDate(tender.tenderPublishDate),
        bidSubmissionStartDate: formatDateTime(tender.bidSubmissionStartDate),
        bidSubmissionEndDate: formatDateTime(tender.bidSubmissionEndDate),
      }));

    setFilteredRows(mappedRows || []);
  }, [tenders]);

  useEffect(() => {
    const lowercasedSearch = searchText.toLowerCase();

    const newFilteredRows = (rows || []).filter((row) => {
      const title = row?.tender?.title?.toLowerCase() || "";
      const tenderType = row?.tender?.type?.toLowerCase() || "";
      const status = row?.vtStatus?.toLowerCase() || "";
      const publishDate = row?.tender?.tenderPublishDate
        ? formatDate(row.tender.tenderPublishDate).toLowerCase()
        : "";

      const bidCloseDate = row?.tender?.bidSubmissionEndDate
        ? formatDateTime(row.tender.bidSubmissionEndDate).toLowerCase()
        : "";

      return (
        title.includes(lowercasedSearch) ||
        tenderType.includes(lowercasedSearch) ||
        status.includes(lowercasedSearch) ||
        publishDate.includes(lowercasedSearch) ||
        bidCloseDate.includes(lowercasedSearch)
      );
    });

    setFilteredRows(newFilteredRows);
  }, [searchText]);

  const handleEMDChange = (e) => {
    setEmdDetails({ ...emdDetails, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleFileUpload = async (e) => {
    const { name, files } = e.target;
    setUploading(true);
    if (files && files.length > 0) {
      const file = files[0]; // Get the first file

      // Update the file names state
      setFileNames((prev) => ({
        ...prev,
        [name]: file.name, // Set the filename in state
      }));

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res = await uploadFile(file, tender.orgId, tender.tenderId, storedUser)
        // Set the received file path in tender state
        setEmdDetails({ ...emdDetails, [e.target.name]: res });
        setErrors({ ...errors, [e.target.name]: "" });
      } catch (error) {
        console.error("File upload error:", error);
      } finally {
        setUploading(false);
      }
    }
  };

  const handleEMDSubmit = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/vendor-emd`,
        {
          vendorId: vendorId,
          tenderId: tender.tenderId,
          utr: emdDetails.utr,
          document: emdDetails.document,
          documentFilename: fileNames.document,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOpenEMDModal(false);
      setOpenConfirm(false);
      setFileNames({ document: "" });
      setEmdDetails();
      getTenders();
    } catch (error) {
      console.error("Error updating tender status:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTenders(paginationModel.page);
  }, [paginationModel]);

  const handlePaginationChange = (model) => {
    setPaginationModel(model);
  };

  const handleChange = (e) => {
      setPurchase({ ...purchase, [e.target.name]: e.target.value });
      setErrors({ ...errors, [e.target.name]: "" });
    };
  
    const handlePurchaseFileUpload = async (e) => {
      const { name, files } = e.target;
      setUploading(true);
      if (files && files.length > 0) {
        const file = files[0]; // Get the first file
  
        // Update the file names state
        setFileNames((prev) => ({
          ...prev,
          [name]: file.name, // Set the filename in state
        }));
  
        const formData = new FormData();
        formData.append("file", file);
  
        try {
          const res = await uploadFile(file, 
            selectedTenders[0].tender.organization.orgId, 
            selectedTenders[0].tender.tenderId, 
            storedUser)
          // Set the received file path in tender state
          setPurchase({ ...purchase, [e.target.name]: res });
          setErrors({ ...errors, [e.target.name]: "" });
        } catch (error) {
          console.error("File upload error:", error);
        } finally {
          setUploading(false);
        }
      }
    };
  
    const validatePurchaseForm = () => {
      const newErrors = {};
      const data = purchase || {};
  
      const isEmpty = (value) => !value || value.trim?.() === "";
  
      if (isEmpty(data.utr)) newErrors.utr = "UTR Number is required";
      if (isEmpty(data.document)) newErrors.document = "Document is required";
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    const handlePurchaseSubmit = async () => {
      // if (!validatePurchaseForm()) return;
      setBtnLoading(true);
      try {
        // await axios.post(
        //   `${process.env.REACT_APP_BACKEND_URL}/vendor-purchase`,
        //   {
        //     vendorId: vendorId,
        //     // tenderId: searchTender.tenderId,
        //     utr: purchase.utr,
        //     document: purchase.document,
        //     documentFilename: fileNames.document,
        //   },
        //   { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        // );
        setFilteredRows((prev) =>
  prev.map((row) =>
    selectedTenders.some((t) => t.vtId === row.vtId)
      ? { ...row, vtStatus: "PURCHASE_SUBMITTED" }
      : row
  )
);
        setOpenPurchase(false);
        setOpenConfirm(false);
        setFileNames({ document: "" });
        setPurchase();
        // setSearchTender("");
        // setId("");
        setSelectedTenders([]);
      } catch (error) {
        console.error("Error updating tender status:", error);
      } finally {
        setBtnLoading(false);
      }
    };
  return (
    <div style={{ position: "relative" }}>
      {loading && <div className="loading-div"></div>}
      <Box sx={{ background: "#fff" }}>
        <Box sx={{ display: "flex", justifyContent: "end", mt: 2 }}>
          <TextField
            placeholder="Search"
            size="small"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{
              borderRadius: "12px",
              background: "#fff",
              width: 300,
              "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              "&:hover": { background: "#D8E9F0" },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          loading={isLoading}
          checkboxSelection
  onRowSelectionModelChange={(ids) => {
    const selectedRows = filteredRows.filter((row) => ids.includes(row.vtId));
    setSelectedTenders(selectedRows);
  }}
  isRowSelectable={(params) => params.row.vtStatus === "INTERESTED"}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10]}
          pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationChange}
          rowCount={totalCount}
          disableRowSelectionOnClick
          disableColumnSelector
          disableDensitySelector
          disableColumnMenu
          disableColumnResize
          getRowId={(row) => row.vtId}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
          sx={{
            position: "relative",
            border: "none",
            fontFamily: "Inter !important",

            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "700 !important",
            },
            "& .MuiDataGrid-columnHeaders": {
              background: "none !important",
              color: "black",
              fontSize: "14px",
              borderRadius: "10px",
            },
            "& .MuiDataGrid-row:hover": {
              backgroundColor: "#fff",
            },
            "& .MuiDataGrid-cell": {
              fontSize: "13px",
              border: "none",
            },
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
              color: "#000 !important",
              border: "1px solid #B0B0B0",
              borderRadius: "12px",
              padding: 1,
            },
            "& .MuiInputBase-root-MuiInput-root::after": {
              borderBottom: "none !important",
            },
            "& .MuiInputBase-root-MuiInput-root": {
              borderBottom: "none !important",
            },
            [`& .${gridClasses.row}.even`]: {
              backgroundColor: "#EAF4FF",
              // '&:hover': {
              //   backgroundColor: "#f6f6f6",
              // },
            },
            "& .MuiInput-underline:before": {
              borderBottom: "none !important",
            },
            "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
              borderBottom: "none !important",
            },
          }}
        />

        <Modal
          open={openNewModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-description">
              Please fill your first form carefully, you can reuse details from
              this in your future forms.
            </Typography>
            <Button className="btn-contained" onClick={handleGoToNewForm}>
              Acknowledge
            </Button>
          </Box>
        </Modal>

        <Modal
          open={openImportModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-description">
              "We have details from your last submitted vendor qualification. Do
              you want to fetch data from there?
              <br />
              <br />
              You can still edit any information that you want."
            </Typography>
            <Box className="btn-container" sx={{ gap: 4, width: "80%" }}>
              <Button
                className="btn-outlined"
                sx={{ width: "100%" }}
                onClick={handleGoToNewForm}
              >
                Blank Form
              </Button>
              <Button
                className="btn-contained"
                sx={{ width: "100%" }}
                onClick={handleImportForm}
              >
                Import
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={openEMDModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...style, textAlign: "start" }}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              textAlign={"start"}
            >
              Enter EMD Details
            </Typography>
            <Typography id="modal-modal-description" mb={2}>
              Please enter EMD details below <br />
              <br />
              Please transfer the EMD amount of{" "}
              <strong>Rs.{tender?.emdAmount} on the below account</strong>
              <br />
              Account Holder Name: <strong>{tender?.accountName}</strong>
              <br />
              Account Number: <strong>{tender?.accountNumber}</strong>
              <br />
              Bank Name: <strong>{tender?.emdBank}</strong>
              <br />
              IFSC Code: <strong>{tender?.ifsc}</strong>
              <br />
              <br />
              Once paid, please enter the details below
            </Typography>
            <label htmlFor="utr">UTR Number</label>
            <input
              type="text"
              name="utr"
              id="utr"
              placeholder="Enter Your UTR Number Here"
              onChange={handleEMDChange}
              className={`${errors.utr && "input-error"}`}
            />
            {errors.utr && <p className="error">{errors.utr}</p>}
            <label htmlFor="document">
              Upload Document
              <div className={`input-file ${errors.document && "input-error"}`}>
                <input
                  type="file"
                  id="document"
                  name="document"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.document || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            {errors.document && <p className="error">{errors.document}</p>}
            {uploading && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
            {emdDetails && emdDetails.document && (
              <Button
                sx={{
                  margin: "-6% 0 0 0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewPDF(emdDetails.document, storedUser)}
              >
                {fileNames.document}
              </Button>
            )}
            <Box className="btn-container" sx={{ gap: 4, width: "80%" }}>
              <Button
                className="btn-contained"
                onClick={() => setOpenConfirm(true)}
                disabled={loading}
              >
                {loading ? "Submitting" : "Submit"}
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>

      <Modal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to submit these details?
          </Typography>
          <Box className="btn-container" sx={{ gap: 3, width: "100%" }}>
            <Button
              className="btn-outlined"
              variant="outlined"
              onClick={() => setOpenConfirm(false)}
            >
              No
            </Button>
            <Button
              className="btn-contained"
              onClick={handleEMDSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Yes"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
              open={openPurchase}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={{ ...style, textAlign: "start" }}>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  textAlign={"start"}
                >
                  Enter Purchase Details
                </Typography>
                <Typography id="modal-modal-description" mb={2}>
                  Please enter Purchase details below <br />
                  <br />
                  Please transfer the Purchase amount of{" "}
                  <strong>
                    Rs.{totalPurchaseAmount} on the below account for {selectedTenders.length} tenders
                  </strong>
                  {/* <br />
                  Account Holder Name:{" "}
                  <strong>{searchTender?.purchaseAccountName}</strong>
                  <br />
                  Account Number:{" "}
                  <strong>{searchTender?.purchaseAccountNumber}</strong>
                  <br />
                  Bank Name: <strong>{searchTender?.purchaseBank}</strong>
                  <br />
                  IFSC Code: <strong>{searchTender?.purchaseIfsc}</strong> */}
                  <br />
                  <br />
                  Once paid, please enter the details below
                </Typography>
                <label htmlFor="utr">UTR Number</label>
                <input
                  type="text"
                  name="utr"
                  id="utr"
                  placeholder="Enter Your UTR Number Here"
                  onChange={handleChange}
                  className={`${errors.utr && "input-error"}`}
                />
                {errors.utr && <p className="error">{errors.utr}</p>}
                <label htmlFor="document">
                  Upload Document
                  <div className={`input-file ${errors.document && "input-error"}`}>
                    <input
                      type="file"
                      id="document"
                      name="document"
                      onChange={handlePurchaseFileUpload}
                    />
                    <span
                      style={{
                        width: "80%",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                    >
                      {fileNames.document || "No file chosen"}
                    </span>
                    <AttachFileIcon
                      fontSize="small"
                      sx={{
                        color: "#555",
                        transform: "rotate(90deg)",
                        "&:hover": { color: "#1A71F6BF" },
                      }}
                    />
                  </div>
                </label>
                {errors.document && <p className="error">{errors.document}</p>}
                {uploading && <span style={{fontSize: '12px'}}>Uploading File... <CircularProgress size="30px" /></span>}
                {purchase && purchase.document && (
                  <Button
                    sx={{
                      margin: "-6% 0 0 0 !important",
                      width: "max-content !important",
                      fontSize: "12px !important",
                      textDecoration: "underline",
                      textAlign: "start",
                    }}
                    onClick={() => viewPDF(purchase.document, storedUser)}
                  >
                    {fileNames.document}
                  </Button>
                )}
                <Box className="btn-container" sx={{ gap: 4, width: "80%" }}>
                  <Button
                    className="btn-contained"
                    onClick={handlePurchaseSubmit}
                    disabled={btnLoading}
                  >
                    {btnLoading ? "Submitting" : "Submit"}
                  </Button>
                </Box>
              </Box>
            </Modal>
    </div>
  );
};

export default Tenders;
